/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authOauthRouteImport } from './routes/(auth)/oauth'
import { Route as authRegisterRouteImport } from './routes/(auth)/register'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as AuthenticatedSystemSettingsRouteRouteImport } from './routes/_authenticated/system-settings/route'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as DingtalkEntryRouteImport } from './routes/dingtalk/entry'
import { Route as OauthProviderRouteImport } from './routes/oauth/$provider'
import { Route as PricingIndexRouteImport } from './routes/pricing/index'
import { Route as RankingsIndexRouteImport } from './routes/rankings/index'
import { Route as SetupIndexRouteImport } from './routes/setup/index'
import { Route as AuthenticatedApiReferenceIndexRouteImport } from './routes/_authenticated/api-reference/index'
import { Route as AuthenticatedAuditIndexRouteImport } from './routes/_authenticated/audit/index'
import { Route as AuthenticatedChannelsIndexRouteImport } from './routes/_authenticated/channels/index'
import { Route as AuthenticatedChatRecordsIndexRouteImport } from './routes/_authenticated/chat-records/index'
import { Route as AuthenticatedClientReleasesIndexRouteImport } from './routes/_authenticated/client-releases/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardSectionRouteImport } from './routes/_authenticated/dashboard/$section'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedExportCenterIndexRouteImport } from './routes/_authenticated/export-center/index'
import { Route as AuthenticatedKeysIndexRouteImport } from './routes/_authenticated/keys/index'
import { Route as AuthenticatedModelsIndexRouteImport } from './routes/_authenticated/models/index'
import { Route as AuthenticatedModelsSectionRouteImport } from './routes/_authenticated/models/$section'
import { Route as AuthenticatedPlaygroundIndexRouteImport } from './routes/_authenticated/playground/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedQuotaRulesIndexRouteImport } from './routes/_authenticated/quota-rules/index'
import { Route as AuthenticatedRedemptionCodesIndexRouteImport } from './routes/_authenticated/redemption-codes/index'
import { Route as AuthenticatedRunninghubModelsIndexRouteImport } from './routes/_authenticated/runninghub-models/index'
import { Route as AuthenticatedSubscriptionsIndexRouteImport } from './routes/_authenticated/subscriptions/index'
import { Route as AuthenticatedSystemInfoIndexRouteImport } from './routes/_authenticated/system-info/index'
import { Route as AuthenticatedSystemSettingsIndexRouteImport } from './routes/_authenticated/system-settings/index'
import { Route as AuthenticatedUpstreamQuotaIndexRouteImport } from './routes/_authenticated/upstream-quota/index'
import { Route as AuthenticatedUsageLogsIndexRouteImport } from './routes/_authenticated/usage-logs/index'
import { Route as AuthenticatedUsageLogsSectionRouteImport } from './routes/_authenticated/usage-logs/$section'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedVideoAnalysisIndexRouteImport } from './routes/_authenticated/video-analysis/index'
import { Route as AuthenticatedWalletIndexRouteImport } from './routes/_authenticated/wallet/index'
import { Route as PricingModelIdIndexRouteImport } from './routes/pricing/$modelId/index'
import { Route as AuthenticatedChatRecordsRecordsRequest_idRouteImport } from './routes/_authenticated/chat-records/records/$request_id'
import { Route as AuthenticatedChatRecordsSessionsSession_keyRouteImport } from './routes/_authenticated/chat-records/sessions/$session_key'
import { Route as AuthenticatedSystemSettingsAuthIndexRouteImport } from './routes/_authenticated/system-settings/auth/index'
import { Route as AuthenticatedSystemSettingsAuthSectionRouteImport } from './routes/_authenticated/system-settings/auth/$section'
import { Route as AuthenticatedSystemSettingsBillingIndexRouteImport } from './routes/_authenticated/system-settings/billing/index'
import { Route as AuthenticatedSystemSettingsBillingSectionRouteImport } from './routes/_authenticated/system-settings/billing/$section'
import { Route as AuthenticatedSystemSettingsContentIndexRouteImport } from './routes/_authenticated/system-settings/content/index'
import { Route as AuthenticatedSystemSettingsContentSectionRouteImport } from './routes/_authenticated/system-settings/content/$section'
import { Route as AuthenticatedSystemSettingsModelsIndexRouteImport } from './routes/_authenticated/system-settings/models/index'
import { Route as AuthenticatedSystemSettingsModelsSectionRouteImport } from './routes/_authenticated/system-settings/models/$section'
import { Route as AuthenticatedSystemSettingsOperationsIndexRouteImport } from './routes/_authenticated/system-settings/operations/index'
import { Route as AuthenticatedSystemSettingsOperationsSectionRouteImport } from './routes/_authenticated/system-settings/operations/$section'
import { Route as AuthenticatedSystemSettingsSecurityIndexRouteImport } from './routes/_authenticated/system-settings/security/index'
import { Route as AuthenticatedSystemSettingsSecuritySectionRouteImport } from './routes/_authenticated/system-settings/security/$section'
import { Route as AuthenticatedSystemSettingsSiteIndexRouteImport } from './routes/_authenticated/system-settings/site/index'
import { Route as AuthenticatedSystemSettingsSiteSectionRouteImport } from './routes/_authenticated/system-settings/site/$section'
import { Route as AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRouteImport } from './routes/_authenticated/chat-records/sessions/$session_key.calls.$request_id'
import { Route as AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRouteImport } from './routes/_authenticated/chat-records/sessions/$session_key.turns.$turn_id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authOauthRoute = authOauthRouteImport.update({
  id: '/oauth',
  path: '/oauth',
  getParentRoute: () => authRouteRoute,
} as any)
const authRegisterRoute = authRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => authRouteRoute,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSystemSettingsRouteRoute =
  AuthenticatedSystemSettingsRouteRouteImport.update({
    id: '/system-settings',
    path: '/system-settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AboutIndexRoute = AboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => rootRouteImport,
} as any)
const DingtalkEntryRoute = DingtalkEntryRouteImport.update({
  id: '/dingtalk/entry',
  path: '/dingtalk/entry',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthProviderRoute = OauthProviderRouteImport.update({
  id: '/oauth/$provider',
  path: '/oauth/$provider',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingIndexRoute = PricingIndexRouteImport.update({
  id: '/pricing/',
  path: '/pricing/',
  getParentRoute: () => rootRouteImport,
} as any)
const RankingsIndexRoute = RankingsIndexRouteImport.update({
  id: '/rankings/',
  path: '/rankings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupIndexRoute = SetupIndexRouteImport.update({
  id: '/setup/',
  path: '/setup/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedApiReferenceIndexRoute =
  AuthenticatedApiReferenceIndexRouteImport.update({
    id: '/api-reference/',
    path: '/api-reference/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedAuditIndexRoute = AuthenticatedAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedChannelsIndexRoute =
  AuthenticatedChannelsIndexRouteImport.update({
    id: '/channels/',
    path: '/channels/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatRecordsIndexRoute =
  AuthenticatedChatRecordsIndexRouteImport.update({
    id: '/chat-records/',
    path: '/chat-records/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedClientReleasesIndexRoute =
  AuthenticatedClientReleasesIndexRouteImport.update({
    id: '/client-releases/',
    path: '/client-releases/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDashboardSectionRoute =
  AuthenticatedDashboardSectionRouteImport.update({
    id: '/dashboard/$section',
    path: '/dashboard/$section',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedExportCenterIndexRoute =
  AuthenticatedExportCenterIndexRouteImport.update({
    id: '/export-center/',
    path: '/export-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedKeysIndexRoute = AuthenticatedKeysIndexRouteImport.update({
  id: '/keys/',
  path: '/keys/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedModelsIndexRoute =
  AuthenticatedModelsIndexRouteImport.update({
    id: '/models/',
    path: '/models/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedModelsSectionRoute =
  AuthenticatedModelsSectionRouteImport.update({
    id: '/models/$section',
    path: '/models/$section',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPlaygroundIndexRoute =
  AuthenticatedPlaygroundIndexRouteImport.update({
    id: '/playground/',
    path: '/playground/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedQuotaRulesIndexRoute =
  AuthenticatedQuotaRulesIndexRouteImport.update({
    id: '/quota-rules/',
    path: '/quota-rules/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRedemptionCodesIndexRoute =
  AuthenticatedRedemptionCodesIndexRouteImport.update({
    id: '/redemption-codes/',
    path: '/redemption-codes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRunninghubModelsIndexRoute =
  AuthenticatedRunninghubModelsIndexRouteImport.update({
    id: '/runninghub-models/',
    path: '/runninghub-models/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSubscriptionsIndexRoute =
  AuthenticatedSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemInfoIndexRoute =
  AuthenticatedSystemInfoIndexRouteImport.update({
    id: '/system-info/',
    path: '/system-info/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemSettingsIndexRoute =
  AuthenticatedSystemSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedUpstreamQuotaIndexRoute =
  AuthenticatedUpstreamQuotaIndexRouteImport.update({
    id: '/upstream-quota/',
    path: '/upstream-quota/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsageLogsIndexRoute =
  AuthenticatedUsageLogsIndexRouteImport.update({
    id: '/usage-logs/',
    path: '/usage-logs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsageLogsSectionRoute =
  AuthenticatedUsageLogsSectionRouteImport.update({
    id: '/usage-logs/$section',
    path: '/usage-logs/$section',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedVideoAnalysisIndexRoute =
  AuthenticatedVideoAnalysisIndexRouteImport.update({
    id: '/video-analysis/',
    path: '/video-analysis/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedWalletIndexRoute =
  AuthenticatedWalletIndexRouteImport.update({
    id: '/wallet/',
    path: '/wallet/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const PricingModelIdIndexRoute = PricingModelIdIndexRouteImport.update({
  id: '/pricing/$modelId/',
  path: '/pricing/$modelId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedChatRecordsRecordsRequest_idRoute =
  AuthenticatedChatRecordsRecordsRequest_idRouteImport.update({
    id: '/chat-records/records/$request_id',
    path: '/chat-records/records/$request_id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatRecordsSessionsSession_keyRoute =
  AuthenticatedChatRecordsSessionsSession_keyRouteImport.update({
    id: '/chat-records/sessions/$session_key',
    path: '/chat-records/sessions/$session_key',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemSettingsAuthIndexRoute =
  AuthenticatedSystemSettingsAuthIndexRouteImport.update({
    id: '/auth/',
    path: '/auth/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsAuthSectionRoute =
  AuthenticatedSystemSettingsAuthSectionRouteImport.update({
    id: '/auth/$section',
    path: '/auth/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsBillingIndexRoute =
  AuthenticatedSystemSettingsBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsBillingSectionRoute =
  AuthenticatedSystemSettingsBillingSectionRouteImport.update({
    id: '/billing/$section',
    path: '/billing/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsContentIndexRoute =
  AuthenticatedSystemSettingsContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsContentSectionRoute =
  AuthenticatedSystemSettingsContentSectionRouteImport.update({
    id: '/content/$section',
    path: '/content/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsModelsIndexRoute =
  AuthenticatedSystemSettingsModelsIndexRouteImport.update({
    id: '/models/',
    path: '/models/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsModelsSectionRoute =
  AuthenticatedSystemSettingsModelsSectionRouteImport.update({
    id: '/models/$section',
    path: '/models/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsOperationsIndexRoute =
  AuthenticatedSystemSettingsOperationsIndexRouteImport.update({
    id: '/operations/',
    path: '/operations/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsOperationsSectionRoute =
  AuthenticatedSystemSettingsOperationsSectionRouteImport.update({
    id: '/operations/$section',
    path: '/operations/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsSecurityIndexRoute =
  AuthenticatedSystemSettingsSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsSecuritySectionRoute =
  AuthenticatedSystemSettingsSecuritySectionRouteImport.update({
    id: '/security/$section',
    path: '/security/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsSiteIndexRoute =
  AuthenticatedSystemSettingsSiteIndexRouteImport.update({
    id: '/site/',
    path: '/site/',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedSystemSettingsSiteSectionRoute =
  AuthenticatedSystemSettingsSiteSectionRouteImport.update({
    id: '/site/$section',
    path: '/site/$section',
    getParentRoute: () => AuthenticatedSystemSettingsRouteRoute,
  } as any)
const AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute =
  AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRouteImport.update({
    id: '/calls/$request_id',
    path: '/calls/$request_id',
    getParentRoute: () => AuthenticatedChatRecordsSessionsSession_keyRoute,
  } as any)
const AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute =
  AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRouteImport.update({
    id: '/turns/$turn_id',
    path: '/turns/$turn_id',
    getParentRoute: () => AuthenticatedChatRecordsSessionsSession_keyRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/system-settings': typeof AuthenticatedSystemSettingsRouteRouteWithChildren
  '/oauth': typeof authOauthRoute
  '/register': typeof authRegisterRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/dingtalk/entry': typeof DingtalkEntryRoute
  '/oauth/$provider': typeof OauthProviderRoute
  '/about/': typeof AboutIndexRoute
  '/pricing/': typeof PricingIndexRoute
  '/rankings/': typeof RankingsIndexRoute
  '/setup/': typeof SetupIndexRoute
  '/dashboard/$section': typeof AuthenticatedDashboardSectionRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/models/$section': typeof AuthenticatedModelsSectionRoute
  '/usage-logs/$section': typeof AuthenticatedUsageLogsSectionRoute
  '/api-reference/': typeof AuthenticatedApiReferenceIndexRoute
  '/audit/': typeof AuthenticatedAuditIndexRoute
  '/channels/': typeof AuthenticatedChannelsIndexRoute
  '/chat-records/': typeof AuthenticatedChatRecordsIndexRoute
  '/client-releases/': typeof AuthenticatedClientReleasesIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/export-center/': typeof AuthenticatedExportCenterIndexRoute
  '/keys/': typeof AuthenticatedKeysIndexRoute
  '/models/': typeof AuthenticatedModelsIndexRoute
  '/playground/': typeof AuthenticatedPlaygroundIndexRoute
  '/profile/': typeof AuthenticatedProfileIndexRoute
  '/quota-rules/': typeof AuthenticatedQuotaRulesIndexRoute
  '/redemption-codes/': typeof AuthenticatedRedemptionCodesIndexRoute
  '/runninghub-models/': typeof AuthenticatedRunninghubModelsIndexRoute
  '/subscriptions/': typeof AuthenticatedSubscriptionsIndexRoute
  '/system-info/': typeof AuthenticatedSystemInfoIndexRoute
  '/system-settings/': typeof AuthenticatedSystemSettingsIndexRoute
  '/upstream-quota/': typeof AuthenticatedUpstreamQuotaIndexRoute
  '/usage-logs/': typeof AuthenticatedUsageLogsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/video-analysis/': typeof AuthenticatedVideoAnalysisIndexRoute
  '/wallet/': typeof AuthenticatedWalletIndexRoute
  '/pricing/$modelId/': typeof PricingModelIdIndexRoute
  '/chat-records/records/$request_id': typeof AuthenticatedChatRecordsRecordsRequest_idRoute
  '/chat-records/sessions/$session_key': typeof AuthenticatedChatRecordsSessionsSession_keyRouteWithChildren
  '/system-settings/auth/$section': typeof AuthenticatedSystemSettingsAuthSectionRoute
  '/system-settings/billing/$section': typeof AuthenticatedSystemSettingsBillingSectionRoute
  '/system-settings/content/$section': typeof AuthenticatedSystemSettingsContentSectionRoute
  '/system-settings/models/$section': typeof AuthenticatedSystemSettingsModelsSectionRoute
  '/system-settings/operations/$section': typeof AuthenticatedSystemSettingsOperationsSectionRoute
  '/system-settings/security/$section': typeof AuthenticatedSystemSettingsSecuritySectionRoute
  '/system-settings/site/$section': typeof AuthenticatedSystemSettingsSiteSectionRoute
  '/system-settings/auth/': typeof AuthenticatedSystemSettingsAuthIndexRoute
  '/system-settings/billing/': typeof AuthenticatedSystemSettingsBillingIndexRoute
  '/system-settings/content/': typeof AuthenticatedSystemSettingsContentIndexRoute
  '/system-settings/models/': typeof AuthenticatedSystemSettingsModelsIndexRoute
  '/system-settings/operations/': typeof AuthenticatedSystemSettingsOperationsIndexRoute
  '/system-settings/security/': typeof AuthenticatedSystemSettingsSecurityIndexRoute
  '/system-settings/site/': typeof AuthenticatedSystemSettingsSiteIndexRoute
  '/chat-records/sessions/$session_key/calls/$request_id': typeof AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute
  '/chat-records/sessions/$session_key/turns/$turn_id': typeof AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/oauth': typeof authOauthRoute
  '/register': typeof authRegisterRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/dingtalk/entry': typeof DingtalkEntryRoute
  '/oauth/$provider': typeof OauthProviderRoute
  '/about': typeof AboutIndexRoute
  '/pricing': typeof PricingIndexRoute
  '/rankings': typeof RankingsIndexRoute
  '/setup': typeof SetupIndexRoute
  '/dashboard/$section': typeof AuthenticatedDashboardSectionRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/models/$section': typeof AuthenticatedModelsSectionRoute
  '/usage-logs/$section': typeof AuthenticatedUsageLogsSectionRoute
  '/api-reference': typeof AuthenticatedApiReferenceIndexRoute
  '/audit': typeof AuthenticatedAuditIndexRoute
  '/channels': typeof AuthenticatedChannelsIndexRoute
  '/chat-records': typeof AuthenticatedChatRecordsIndexRoute
  '/client-releases': typeof AuthenticatedClientReleasesIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/export-center': typeof AuthenticatedExportCenterIndexRoute
  '/keys': typeof AuthenticatedKeysIndexRoute
  '/models': typeof AuthenticatedModelsIndexRoute
  '/playground': typeof AuthenticatedPlaygroundIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/quota-rules': typeof AuthenticatedQuotaRulesIndexRoute
  '/redemption-codes': typeof AuthenticatedRedemptionCodesIndexRoute
  '/runninghub-models': typeof AuthenticatedRunninghubModelsIndexRoute
  '/subscriptions': typeof AuthenticatedSubscriptionsIndexRoute
  '/system-info': typeof AuthenticatedSystemInfoIndexRoute
  '/system-settings': typeof AuthenticatedSystemSettingsIndexRoute
  '/upstream-quota': typeof AuthenticatedUpstreamQuotaIndexRoute
  '/usage-logs': typeof AuthenticatedUsageLogsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/video-analysis': typeof AuthenticatedVideoAnalysisIndexRoute
  '/wallet': typeof AuthenticatedWalletIndexRoute
  '/pricing/$modelId': typeof PricingModelIdIndexRoute
  '/chat-records/records/$request_id': typeof AuthenticatedChatRecordsRecordsRequest_idRoute
  '/chat-records/sessions/$session_key': typeof AuthenticatedChatRecordsSessionsSession_keyRouteWithChildren
  '/system-settings/auth/$section': typeof AuthenticatedSystemSettingsAuthSectionRoute
  '/system-settings/billing/$section': typeof AuthenticatedSystemSettingsBillingSectionRoute
  '/system-settings/content/$section': typeof AuthenticatedSystemSettingsContentSectionRoute
  '/system-settings/models/$section': typeof AuthenticatedSystemSettingsModelsSectionRoute
  '/system-settings/operations/$section': typeof AuthenticatedSystemSettingsOperationsSectionRoute
  '/system-settings/security/$section': typeof AuthenticatedSystemSettingsSecuritySectionRoute
  '/system-settings/site/$section': typeof AuthenticatedSystemSettingsSiteSectionRoute
  '/system-settings/auth': typeof AuthenticatedSystemSettingsAuthIndexRoute
  '/system-settings/billing': typeof AuthenticatedSystemSettingsBillingIndexRoute
  '/system-settings/content': typeof AuthenticatedSystemSettingsContentIndexRoute
  '/system-settings/models': typeof AuthenticatedSystemSettingsModelsIndexRoute
  '/system-settings/operations': typeof AuthenticatedSystemSettingsOperationsIndexRoute
  '/system-settings/security': typeof AuthenticatedSystemSettingsSecurityIndexRoute
  '/system-settings/site': typeof AuthenticatedSystemSettingsSiteIndexRoute
  '/chat-records/sessions/$session_key/calls/$request_id': typeof AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute
  '/chat-records/sessions/$session_key/turns/$turn_id': typeof AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/system-settings': typeof AuthenticatedSystemSettingsRouteRouteWithChildren
  '/(auth)/oauth': typeof authOauthRoute
  '/(auth)/register': typeof authRegisterRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/dingtalk/entry': typeof DingtalkEntryRoute
  '/oauth/$provider': typeof OauthProviderRoute
  '/about/': typeof AboutIndexRoute
  '/pricing/': typeof PricingIndexRoute
  '/rankings/': typeof RankingsIndexRoute
  '/setup/': typeof SetupIndexRoute
  '/_authenticated/dashboard/$section': typeof AuthenticatedDashboardSectionRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/models/$section': typeof AuthenticatedModelsSectionRoute
  '/_authenticated/usage-logs/$section': typeof AuthenticatedUsageLogsSectionRoute
  '/_authenticated/api-reference/': typeof AuthenticatedApiReferenceIndexRoute
  '/_authenticated/audit/': typeof AuthenticatedAuditIndexRoute
  '/_authenticated/channels/': typeof AuthenticatedChannelsIndexRoute
  '/_authenticated/chat-records/': typeof AuthenticatedChatRecordsIndexRoute
  '/_authenticated/client-releases/': typeof AuthenticatedClientReleasesIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/export-center/': typeof AuthenticatedExportCenterIndexRoute
  '/_authenticated/keys/': typeof AuthenticatedKeysIndexRoute
  '/_authenticated/models/': typeof AuthenticatedModelsIndexRoute
  '/_authenticated/playground/': typeof AuthenticatedPlaygroundIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/quota-rules/': typeof AuthenticatedQuotaRulesIndexRoute
  '/_authenticated/redemption-codes/': typeof AuthenticatedRedemptionCodesIndexRoute
  '/_authenticated/runninghub-models/': typeof AuthenticatedRunninghubModelsIndexRoute
  '/_authenticated/subscriptions/': typeof AuthenticatedSubscriptionsIndexRoute
  '/_authenticated/system-info/': typeof AuthenticatedSystemInfoIndexRoute
  '/_authenticated/system-settings/': typeof AuthenticatedSystemSettingsIndexRoute
  '/_authenticated/upstream-quota/': typeof AuthenticatedUpstreamQuotaIndexRoute
  '/_authenticated/usage-logs/': typeof AuthenticatedUsageLogsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/video-analysis/': typeof AuthenticatedVideoAnalysisIndexRoute
  '/_authenticated/wallet/': typeof AuthenticatedWalletIndexRoute
  '/pricing/$modelId/': typeof PricingModelIdIndexRoute
  '/_authenticated/chat-records/records/$request_id': typeof AuthenticatedChatRecordsRecordsRequest_idRoute
  '/_authenticated/chat-records/sessions/$session_key': typeof AuthenticatedChatRecordsSessionsSession_keyRouteWithChildren
  '/_authenticated/system-settings/auth/$section': typeof AuthenticatedSystemSettingsAuthSectionRoute
  '/_authenticated/system-settings/billing/$section': typeof AuthenticatedSystemSettingsBillingSectionRoute
  '/_authenticated/system-settings/content/$section': typeof AuthenticatedSystemSettingsContentSectionRoute
  '/_authenticated/system-settings/models/$section': typeof AuthenticatedSystemSettingsModelsSectionRoute
  '/_authenticated/system-settings/operations/$section': typeof AuthenticatedSystemSettingsOperationsSectionRoute
  '/_authenticated/system-settings/security/$section': typeof AuthenticatedSystemSettingsSecuritySectionRoute
  '/_authenticated/system-settings/site/$section': typeof AuthenticatedSystemSettingsSiteSectionRoute
  '/_authenticated/system-settings/auth/': typeof AuthenticatedSystemSettingsAuthIndexRoute
  '/_authenticated/system-settings/billing/': typeof AuthenticatedSystemSettingsBillingIndexRoute
  '/_authenticated/system-settings/content/': typeof AuthenticatedSystemSettingsContentIndexRoute
  '/_authenticated/system-settings/models/': typeof AuthenticatedSystemSettingsModelsIndexRoute
  '/_authenticated/system-settings/operations/': typeof AuthenticatedSystemSettingsOperationsIndexRoute
  '/_authenticated/system-settings/security/': typeof AuthenticatedSystemSettingsSecurityIndexRoute
  '/_authenticated/system-settings/site/': typeof AuthenticatedSystemSettingsSiteIndexRoute
  '/_authenticated/chat-records/sessions/$session_key/calls/$request_id': typeof AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute
  '/_authenticated/chat-records/sessions/$session_key/turns/$turn_id': typeof AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/system-settings'
    | '/oauth'
    | '/register'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/dingtalk/entry'
    | '/oauth/$provider'
    | '/about/'
    | '/pricing/'
    | '/rankings/'
    | '/setup/'
    | '/dashboard/$section'
    | '/errors/$error'
    | '/models/$section'
    | '/usage-logs/$section'
    | '/api-reference/'
    | '/audit/'
    | '/channels/'
    | '/chat-records/'
    | '/client-releases/'
    | '/dashboard/'
    | '/export-center/'
    | '/keys/'
    | '/models/'
    | '/playground/'
    | '/profile/'
    | '/quota-rules/'
    | '/redemption-codes/'
    | '/runninghub-models/'
    | '/subscriptions/'
    | '/system-info/'
    | '/system-settings/'
    | '/upstream-quota/'
    | '/usage-logs/'
    | '/users/'
    | '/video-analysis/'
    | '/wallet/'
    | '/pricing/$modelId/'
    | '/chat-records/records/$request_id'
    | '/chat-records/sessions/$session_key'
    | '/system-settings/auth/$section'
    | '/system-settings/billing/$section'
    | '/system-settings/content/$section'
    | '/system-settings/models/$section'
    | '/system-settings/operations/$section'
    | '/system-settings/security/$section'
    | '/system-settings/site/$section'
    | '/system-settings/auth/'
    | '/system-settings/billing/'
    | '/system-settings/content/'
    | '/system-settings/models/'
    | '/system-settings/operations/'
    | '/system-settings/security/'
    | '/system-settings/site/'
    | '/chat-records/sessions/$session_key/calls/$request_id'
    | '/chat-records/sessions/$session_key/turns/$turn_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/oauth'
    | '/register'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/dingtalk/entry'
    | '/oauth/$provider'
    | '/about'
    | '/pricing'
    | '/rankings'
    | '/setup'
    | '/dashboard/$section'
    | '/errors/$error'
    | '/models/$section'
    | '/usage-logs/$section'
    | '/api-reference'
    | '/audit'
    | '/channels'
    | '/chat-records'
    | '/client-releases'
    | '/dashboard'
    | '/export-center'
    | '/keys'
    | '/models'
    | '/playground'
    | '/profile'
    | '/quota-rules'
    | '/redemption-codes'
    | '/runninghub-models'
    | '/subscriptions'
    | '/system-info'
    | '/system-settings'
    | '/upstream-quota'
    | '/usage-logs'
    | '/users'
    | '/video-analysis'
    | '/wallet'
    | '/pricing/$modelId'
    | '/chat-records/records/$request_id'
    | '/chat-records/sessions/$session_key'
    | '/system-settings/auth/$section'
    | '/system-settings/billing/$section'
    | '/system-settings/content/$section'
    | '/system-settings/models/$section'
    | '/system-settings/operations/$section'
    | '/system-settings/security/$section'
    | '/system-settings/site/$section'
    | '/system-settings/auth'
    | '/system-settings/billing'
    | '/system-settings/content'
    | '/system-settings/models'
    | '/system-settings/operations'
    | '/system-settings/security'
    | '/system-settings/site'
    | '/chat-records/sessions/$session_key/calls/$request_id'
    | '/chat-records/sessions/$session_key/turns/$turn_id'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/_authenticated'
    | '/_authenticated/system-settings'
    | '/(auth)/oauth'
    | '/(auth)/register'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/dingtalk/entry'
    | '/oauth/$provider'
    | '/about/'
    | '/pricing/'
    | '/rankings/'
    | '/setup/'
    | '/_authenticated/dashboard/$section'
    | '/_authenticated/errors/$error'
    | '/_authenticated/models/$section'
    | '/_authenticated/usage-logs/$section'
    | '/_authenticated/api-reference/'
    | '/_authenticated/audit/'
    | '/_authenticated/channels/'
    | '/_authenticated/chat-records/'
    | '/_authenticated/client-releases/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/export-center/'
    | '/_authenticated/keys/'
    | '/_authenticated/models/'
    | '/_authenticated/playground/'
    | '/_authenticated/profile/'
    | '/_authenticated/quota-rules/'
    | '/_authenticated/redemption-codes/'
    | '/_authenticated/runninghub-models/'
    | '/_authenticated/subscriptions/'
    | '/_authenticated/system-info/'
    | '/_authenticated/system-settings/'
    | '/_authenticated/upstream-quota/'
    | '/_authenticated/usage-logs/'
    | '/_authenticated/users/'
    | '/_authenticated/video-analysis/'
    | '/_authenticated/wallet/'
    | '/pricing/$modelId/'
    | '/_authenticated/chat-records/records/$request_id'
    | '/_authenticated/chat-records/sessions/$session_key'
    | '/_authenticated/system-settings/auth/$section'
    | '/_authenticated/system-settings/billing/$section'
    | '/_authenticated/system-settings/content/$section'
    | '/_authenticated/system-settings/models/$section'
    | '/_authenticated/system-settings/operations/$section'
    | '/_authenticated/system-settings/security/$section'
    | '/_authenticated/system-settings/site/$section'
    | '/_authenticated/system-settings/auth/'
    | '/_authenticated/system-settings/billing/'
    | '/_authenticated/system-settings/content/'
    | '/_authenticated/system-settings/models/'
    | '/_authenticated/system-settings/operations/'
    | '/_authenticated/system-settings/security/'
    | '/_authenticated/system-settings/site/'
    | '/_authenticated/chat-records/sessions/$session_key/calls/$request_id'
    | '/_authenticated/chat-records/sessions/$session_key/turns/$turn_id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
  DingtalkEntryRoute: typeof DingtalkEntryRoute
  OauthProviderRoute: typeof OauthProviderRoute
  AboutIndexRoute: typeof AboutIndexRoute
  PricingIndexRoute: typeof PricingIndexRoute
  RankingsIndexRoute: typeof RankingsIndexRoute
  SetupIndexRoute: typeof SetupIndexRoute
  PricingModelIdIndexRoute: typeof PricingModelIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/oauth': {
      id: '/(auth)/oauth'
      path: '/oauth'
      fullPath: '/oauth'
      preLoaderRoute: typeof authOauthRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/register': {
      id: '/(auth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof authRegisterRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/system-settings': {
      id: '/_authenticated/system-settings'
      path: '/system-settings'
      fullPath: '/system-settings'
      preLoaderRoute: typeof AuthenticatedSystemSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about/'
      preLoaderRoute: typeof AboutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dingtalk/entry': {
      id: '/dingtalk/entry'
      path: '/dingtalk/entry'
      fullPath: '/dingtalk/entry'
      preLoaderRoute: typeof DingtalkEntryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/$provider': {
      id: '/oauth/$provider'
      path: '/oauth/$provider'
      fullPath: '/oauth/$provider'
      preLoaderRoute: typeof OauthProviderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing/': {
      id: '/pricing/'
      path: '/pricing'
      fullPath: '/pricing/'
      preLoaderRoute: typeof PricingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rankings/': {
      id: '/rankings/'
      path: '/rankings'
      fullPath: '/rankings/'
      preLoaderRoute: typeof RankingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup/': {
      id: '/setup/'
      path: '/setup'
      fullPath: '/setup/'
      preLoaderRoute: typeof SetupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/api-reference/': {
      id: '/_authenticated/api-reference/'
      path: '/api-reference'
      fullPath: '/api-reference/'
      preLoaderRoute: typeof AuthenticatedApiReferenceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/audit/': {
      id: '/_authenticated/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthenticatedAuditIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/channels/': {
      id: '/_authenticated/channels/'
      path: '/channels'
      fullPath: '/channels/'
      preLoaderRoute: typeof AuthenticatedChannelsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chat-records/': {
      id: '/_authenticated/chat-records/'
      path: '/chat-records'
      fullPath: '/chat-records/'
      preLoaderRoute: typeof AuthenticatedChatRecordsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/client-releases/': {
      id: '/_authenticated/client-releases/'
      path: '/client-releases'
      fullPath: '/client-releases/'
      preLoaderRoute: typeof AuthenticatedClientReleasesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/dashboard/$section': {
      id: '/_authenticated/dashboard/$section'
      path: '/dashboard/$section'
      fullPath: '/dashboard/$section'
      preLoaderRoute: typeof AuthenticatedDashboardSectionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/export-center/': {
      id: '/_authenticated/export-center/'
      path: '/export-center'
      fullPath: '/export-center/'
      preLoaderRoute: typeof AuthenticatedExportCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/keys/': {
      id: '/_authenticated/keys/'
      path: '/keys'
      fullPath: '/keys/'
      preLoaderRoute: typeof AuthenticatedKeysIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/models/': {
      id: '/_authenticated/models/'
      path: '/models'
      fullPath: '/models/'
      preLoaderRoute: typeof AuthenticatedModelsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/models/$section': {
      id: '/_authenticated/models/$section'
      path: '/models/$section'
      fullPath: '/models/$section'
      preLoaderRoute: typeof AuthenticatedModelsSectionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/playground/': {
      id: '/_authenticated/playground/'
      path: '/playground'
      fullPath: '/playground/'
      preLoaderRoute: typeof AuthenticatedPlaygroundIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/quota-rules/': {
      id: '/_authenticated/quota-rules/'
      path: '/quota-rules'
      fullPath: '/quota-rules/'
      preLoaderRoute: typeof AuthenticatedQuotaRulesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/redemption-codes/': {
      id: '/_authenticated/redemption-codes/'
      path: '/redemption-codes'
      fullPath: '/redemption-codes/'
      preLoaderRoute: typeof AuthenticatedRedemptionCodesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/runninghub-models/': {
      id: '/_authenticated/runninghub-models/'
      path: '/runninghub-models'
      fullPath: '/runninghub-models/'
      preLoaderRoute: typeof AuthenticatedRunninghubModelsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/subscriptions/': {
      id: '/_authenticated/subscriptions/'
      path: '/subscriptions'
      fullPath: '/subscriptions/'
      preLoaderRoute: typeof AuthenticatedSubscriptionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system-info/': {
      id: '/_authenticated/system-info/'
      path: '/system-info'
      fullPath: '/system-info/'
      preLoaderRoute: typeof AuthenticatedSystemInfoIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system-settings/': {
      id: '/_authenticated/system-settings/'
      path: '/'
      fullPath: '/system-settings/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/upstream-quota/': {
      id: '/_authenticated/upstream-quota/'
      path: '/upstream-quota'
      fullPath: '/upstream-quota/'
      preLoaderRoute: typeof AuthenticatedUpstreamQuotaIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/usage-logs/': {
      id: '/_authenticated/usage-logs/'
      path: '/usage-logs'
      fullPath: '/usage-logs/'
      preLoaderRoute: typeof AuthenticatedUsageLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/usage-logs/$section': {
      id: '/_authenticated/usage-logs/$section'
      path: '/usage-logs/$section'
      fullPath: '/usage-logs/$section'
      preLoaderRoute: typeof AuthenticatedUsageLogsSectionRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/video-analysis/': {
      id: '/_authenticated/video-analysis/'
      path: '/video-analysis'
      fullPath: '/video-analysis/'
      preLoaderRoute: typeof AuthenticatedVideoAnalysisIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/wallet/': {
      id: '/_authenticated/wallet/'
      path: '/wallet'
      fullPath: '/wallet/'
      preLoaderRoute: typeof AuthenticatedWalletIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/pricing/$modelId/': {
      id: '/pricing/$modelId/'
      path: '/pricing/$modelId'
      fullPath: '/pricing/$modelId/'
      preLoaderRoute: typeof PricingModelIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/chat-records/records/$request_id': {
      id: '/_authenticated/chat-records/records/$request_id'
      path: '/chat-records/records/$request_id'
      fullPath: '/chat-records/records/$request_id'
      preLoaderRoute: typeof AuthenticatedChatRecordsRecordsRequest_idRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chat-records/sessions/$session_key': {
      id: '/_authenticated/chat-records/sessions/$session_key'
      path: '/chat-records/sessions/$session_key'
      fullPath: '/chat-records/sessions/$session_key'
      preLoaderRoute: typeof AuthenticatedChatRecordsSessionsSession_keyRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system-settings/auth/': {
      id: '/_authenticated/system-settings/auth/'
      path: '/auth'
      fullPath: '/system-settings/auth/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsAuthIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/auth/$section': {
      id: '/_authenticated/system-settings/auth/$section'
      path: '/auth/$section'
      fullPath: '/system-settings/auth/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsAuthSectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/billing/': {
      id: '/_authenticated/system-settings/billing/'
      path: '/billing'
      fullPath: '/system-settings/billing/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsBillingIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/billing/$section': {
      id: '/_authenticated/system-settings/billing/$section'
      path: '/billing/$section'
      fullPath: '/system-settings/billing/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsBillingSectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/content/': {
      id: '/_authenticated/system-settings/content/'
      path: '/content'
      fullPath: '/system-settings/content/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsContentIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/content/$section': {
      id: '/_authenticated/system-settings/content/$section'
      path: '/content/$section'
      fullPath: '/system-settings/content/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsContentSectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/models/': {
      id: '/_authenticated/system-settings/models/'
      path: '/models'
      fullPath: '/system-settings/models/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsModelsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/models/$section': {
      id: '/_authenticated/system-settings/models/$section'
      path: '/models/$section'
      fullPath: '/system-settings/models/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsModelsSectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/operations/': {
      id: '/_authenticated/system-settings/operations/'
      path: '/operations'
      fullPath: '/system-settings/operations/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsOperationsIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/operations/$section': {
      id: '/_authenticated/system-settings/operations/$section'
      path: '/operations/$section'
      fullPath: '/system-settings/operations/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsOperationsSectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/security/': {
      id: '/_authenticated/system-settings/security/'
      path: '/security'
      fullPath: '/system-settings/security/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/security/$section': {
      id: '/_authenticated/system-settings/security/$section'
      path: '/security/$section'
      fullPath: '/system-settings/security/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsSecuritySectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/site/': {
      id: '/_authenticated/system-settings/site/'
      path: '/site'
      fullPath: '/system-settings/site/'
      preLoaderRoute: typeof AuthenticatedSystemSettingsSiteIndexRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/system-settings/site/$section': {
      id: '/_authenticated/system-settings/site/$section'
      path: '/site/$section'
      fullPath: '/system-settings/site/$section'
      preLoaderRoute: typeof AuthenticatedSystemSettingsSiteSectionRouteImport
      parentRoute: typeof AuthenticatedSystemSettingsRouteRoute
    }
    '/_authenticated/chat-records/sessions/$session_key/calls/$request_id': {
      id: '/_authenticated/chat-records/sessions/$session_key/calls/$request_id'
      path: '/calls/$request_id'
      fullPath: '/chat-records/sessions/$session_key/calls/$request_id'
      preLoaderRoute: typeof AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRouteImport
      parentRoute: typeof AuthenticatedChatRecordsSessionsSession_keyRoute
    }
    '/_authenticated/chat-records/sessions/$session_key/turns/$turn_id': {
      id: '/_authenticated/chat-records/sessions/$session_key/turns/$turn_id'
      path: '/turns/$turn_id'
      fullPath: '/chat-records/sessions/$session_key/turns/$turn_id'
      preLoaderRoute: typeof AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRouteImport
      parentRoute: typeof AuthenticatedChatRecordsSessionsSession_keyRoute
    }
  }
}

interface authRouteRouteChildren {
  authOauthRoute: typeof authOauthRoute
  authRegisterRoute: typeof authRegisterRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authOauthRoute: authOauthRoute,
  authRegisterRoute: authRegisterRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedSystemSettingsRouteRouteChildren {
  AuthenticatedSystemSettingsIndexRoute: typeof AuthenticatedSystemSettingsIndexRoute
  AuthenticatedSystemSettingsAuthSectionRoute: typeof AuthenticatedSystemSettingsAuthSectionRoute
  AuthenticatedSystemSettingsBillingSectionRoute: typeof AuthenticatedSystemSettingsBillingSectionRoute
  AuthenticatedSystemSettingsContentSectionRoute: typeof AuthenticatedSystemSettingsContentSectionRoute
  AuthenticatedSystemSettingsModelsSectionRoute: typeof AuthenticatedSystemSettingsModelsSectionRoute
  AuthenticatedSystemSettingsOperationsSectionRoute: typeof AuthenticatedSystemSettingsOperationsSectionRoute
  AuthenticatedSystemSettingsSecuritySectionRoute: typeof AuthenticatedSystemSettingsSecuritySectionRoute
  AuthenticatedSystemSettingsSiteSectionRoute: typeof AuthenticatedSystemSettingsSiteSectionRoute
  AuthenticatedSystemSettingsAuthIndexRoute: typeof AuthenticatedSystemSettingsAuthIndexRoute
  AuthenticatedSystemSettingsBillingIndexRoute: typeof AuthenticatedSystemSettingsBillingIndexRoute
  AuthenticatedSystemSettingsContentIndexRoute: typeof AuthenticatedSystemSettingsContentIndexRoute
  AuthenticatedSystemSettingsModelsIndexRoute: typeof AuthenticatedSystemSettingsModelsIndexRoute
  AuthenticatedSystemSettingsOperationsIndexRoute: typeof AuthenticatedSystemSettingsOperationsIndexRoute
  AuthenticatedSystemSettingsSecurityIndexRoute: typeof AuthenticatedSystemSettingsSecurityIndexRoute
  AuthenticatedSystemSettingsSiteIndexRoute: typeof AuthenticatedSystemSettingsSiteIndexRoute
}

const AuthenticatedSystemSettingsRouteRouteChildren: AuthenticatedSystemSettingsRouteRouteChildren =
  {
    AuthenticatedSystemSettingsIndexRoute:
      AuthenticatedSystemSettingsIndexRoute,
    AuthenticatedSystemSettingsAuthSectionRoute:
      AuthenticatedSystemSettingsAuthSectionRoute,
    AuthenticatedSystemSettingsBillingSectionRoute:
      AuthenticatedSystemSettingsBillingSectionRoute,
    AuthenticatedSystemSettingsContentSectionRoute:
      AuthenticatedSystemSettingsContentSectionRoute,
    AuthenticatedSystemSettingsModelsSectionRoute:
      AuthenticatedSystemSettingsModelsSectionRoute,
    AuthenticatedSystemSettingsOperationsSectionRoute:
      AuthenticatedSystemSettingsOperationsSectionRoute,
    AuthenticatedSystemSettingsSecuritySectionRoute:
      AuthenticatedSystemSettingsSecuritySectionRoute,
    AuthenticatedSystemSettingsSiteSectionRoute:
      AuthenticatedSystemSettingsSiteSectionRoute,
    AuthenticatedSystemSettingsAuthIndexRoute:
      AuthenticatedSystemSettingsAuthIndexRoute,
    AuthenticatedSystemSettingsBillingIndexRoute:
      AuthenticatedSystemSettingsBillingIndexRoute,
    AuthenticatedSystemSettingsContentIndexRoute:
      AuthenticatedSystemSettingsContentIndexRoute,
    AuthenticatedSystemSettingsModelsIndexRoute:
      AuthenticatedSystemSettingsModelsIndexRoute,
    AuthenticatedSystemSettingsOperationsIndexRoute:
      AuthenticatedSystemSettingsOperationsIndexRoute,
    AuthenticatedSystemSettingsSecurityIndexRoute:
      AuthenticatedSystemSettingsSecurityIndexRoute,
    AuthenticatedSystemSettingsSiteIndexRoute:
      AuthenticatedSystemSettingsSiteIndexRoute,
  }

const AuthenticatedSystemSettingsRouteRouteWithChildren =
  AuthenticatedSystemSettingsRouteRoute._addFileChildren(
    AuthenticatedSystemSettingsRouteRouteChildren,
  )

interface AuthenticatedChatRecordsSessionsSession_keyRouteChildren {
  AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute: typeof AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute
  AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute: typeof AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute
}

const AuthenticatedChatRecordsSessionsSession_keyRouteChildren: AuthenticatedChatRecordsSessionsSession_keyRouteChildren =
  {
    AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute:
      AuthenticatedChatRecordsSessionsSession_keyCallsRequest_idRoute,
    AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute:
      AuthenticatedChatRecordsSessionsSession_keyTurnsTurn_idRoute,
  }

const AuthenticatedChatRecordsSessionsSession_keyRouteWithChildren =
  AuthenticatedChatRecordsSessionsSession_keyRoute._addFileChildren(
    AuthenticatedChatRecordsSessionsSession_keyRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSystemSettingsRouteRoute: typeof AuthenticatedSystemSettingsRouteRouteWithChildren
  AuthenticatedDashboardSectionRoute: typeof AuthenticatedDashboardSectionRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedModelsSectionRoute: typeof AuthenticatedModelsSectionRoute
  AuthenticatedUsageLogsSectionRoute: typeof AuthenticatedUsageLogsSectionRoute
  AuthenticatedApiReferenceIndexRoute: typeof AuthenticatedApiReferenceIndexRoute
  AuthenticatedAuditIndexRoute: typeof AuthenticatedAuditIndexRoute
  AuthenticatedChannelsIndexRoute: typeof AuthenticatedChannelsIndexRoute
  AuthenticatedChatRecordsIndexRoute: typeof AuthenticatedChatRecordsIndexRoute
  AuthenticatedClientReleasesIndexRoute: typeof AuthenticatedClientReleasesIndexRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedExportCenterIndexRoute: typeof AuthenticatedExportCenterIndexRoute
  AuthenticatedKeysIndexRoute: typeof AuthenticatedKeysIndexRoute
  AuthenticatedModelsIndexRoute: typeof AuthenticatedModelsIndexRoute
  AuthenticatedPlaygroundIndexRoute: typeof AuthenticatedPlaygroundIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedQuotaRulesIndexRoute: typeof AuthenticatedQuotaRulesIndexRoute
  AuthenticatedRedemptionCodesIndexRoute: typeof AuthenticatedRedemptionCodesIndexRoute
  AuthenticatedRunninghubModelsIndexRoute: typeof AuthenticatedRunninghubModelsIndexRoute
  AuthenticatedSubscriptionsIndexRoute: typeof AuthenticatedSubscriptionsIndexRoute
  AuthenticatedSystemInfoIndexRoute: typeof AuthenticatedSystemInfoIndexRoute
  AuthenticatedUpstreamQuotaIndexRoute: typeof AuthenticatedUpstreamQuotaIndexRoute
  AuthenticatedUsageLogsIndexRoute: typeof AuthenticatedUsageLogsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedVideoAnalysisIndexRoute: typeof AuthenticatedVideoAnalysisIndexRoute
  AuthenticatedWalletIndexRoute: typeof AuthenticatedWalletIndexRoute
  AuthenticatedChatRecordsRecordsRequest_idRoute: typeof AuthenticatedChatRecordsRecordsRequest_idRoute
  AuthenticatedChatRecordsSessionsSession_keyRoute: typeof AuthenticatedChatRecordsSessionsSession_keyRouteWithChildren
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSystemSettingsRouteRoute:
    AuthenticatedSystemSettingsRouteRouteWithChildren,
  AuthenticatedDashboardSectionRoute: AuthenticatedDashboardSectionRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedModelsSectionRoute: AuthenticatedModelsSectionRoute,
  AuthenticatedUsageLogsSectionRoute: AuthenticatedUsageLogsSectionRoute,
  AuthenticatedApiReferenceIndexRoute: AuthenticatedApiReferenceIndexRoute,
  AuthenticatedAuditIndexRoute: AuthenticatedAuditIndexRoute,
  AuthenticatedChannelsIndexRoute: AuthenticatedChannelsIndexRoute,
  AuthenticatedChatRecordsIndexRoute: AuthenticatedChatRecordsIndexRoute,
  AuthenticatedClientReleasesIndexRoute: AuthenticatedClientReleasesIndexRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  AuthenticatedExportCenterIndexRoute: AuthenticatedExportCenterIndexRoute,
  AuthenticatedKeysIndexRoute: AuthenticatedKeysIndexRoute,
  AuthenticatedModelsIndexRoute: AuthenticatedModelsIndexRoute,
  AuthenticatedPlaygroundIndexRoute: AuthenticatedPlaygroundIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedQuotaRulesIndexRoute: AuthenticatedQuotaRulesIndexRoute,
  AuthenticatedRedemptionCodesIndexRoute:
    AuthenticatedRedemptionCodesIndexRoute,
  AuthenticatedRunninghubModelsIndexRoute:
    AuthenticatedRunninghubModelsIndexRoute,
  AuthenticatedSubscriptionsIndexRoute: AuthenticatedSubscriptionsIndexRoute,
  AuthenticatedSystemInfoIndexRoute: AuthenticatedSystemInfoIndexRoute,
  AuthenticatedUpstreamQuotaIndexRoute: AuthenticatedUpstreamQuotaIndexRoute,
  AuthenticatedUsageLogsIndexRoute: AuthenticatedUsageLogsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedVideoAnalysisIndexRoute: AuthenticatedVideoAnalysisIndexRoute,
  AuthenticatedWalletIndexRoute: AuthenticatedWalletIndexRoute,
  AuthenticatedChatRecordsRecordsRequest_idRoute:
    AuthenticatedChatRecordsRecordsRequest_idRoute,
  AuthenticatedChatRecordsSessionsSession_keyRoute:
    AuthenticatedChatRecordsSessionsSession_keyRouteWithChildren,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
  DingtalkEntryRoute: DingtalkEntryRoute,
  OauthProviderRoute: OauthProviderRoute,
  AboutIndexRoute: AboutIndexRoute,
  PricingIndexRoute: PricingIndexRoute,
  RankingsIndexRoute: RankingsIndexRoute,
  SetupIndexRoute: SetupIndexRoute,
  PricingModelIdIndexRoute: PricingModelIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
